import Vue from 'vue'
import App from './App.vue'
// 适配低版本andorid 浏览器使用webrtc
import adapter from 'webrtc-adapter';
// 使用 vue-meta
import Meta from "vue-meta";
Vue.use(Meta);

// import vConsole from 'vconsole'
Vue.config.productionTip = false
// Vue.prototype.$vConsole= new vConsole()
new Vue({
  render: h => h(App),
}).$mount('#app')
